import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-feedback-success',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
    ],
    templateUrl: './feedback-success.component.html',
    styleUrl: './feedback-success.component.scss',
})
export class FeedbackSuccessComponent {
    isAuthenticated: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<FeedbackSuccessComponent>,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
    }

    goToSignIn() {
        this.dialogRef.close();
        this.router.navigate(['/login']);
    }

    goToSignUp() {
        this.dialogRef.close();
        this.router.navigate(['/sign-up']);
    }

    goToDashboard() {
        this.dialogRef.close();
        this.router.navigate(['/feedback-form']);
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
